<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wctime
                    :option="{type:'year',format:'YYYY',clearable:false,width:'140px',ischange:true,placeholder:'请选择年份'}"
                    :value="param.date"
                    @finish="(val)=> {
                        param.date=val.value;
                        param.ischange=true;
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wctime 
                    :option="{clearable:true,width:'300px',ischange:true}"
                    :value="param.time"
                    @finish="(val)=> {
                        param.time=val.value;
                        param.ischange=true;
                    }"
                />
            </el-form-item>
            <el-form-item>
                <div class="TTL-select" style="width:220px">
                <el-select v-model="param.shopid" placeholder="请搜索商户" 
                    filterable  
                    remote 
                    clearable
                    reserve-keyword 
                    @input="changeSelect(index)"
                    @change="param.ischange=true"
                    :remote-method="GetShopLists"
                    >
                    <el-option v-for="(t,i) in shoplist" :key="i" :label="t.shopname" :value="t.id" />
                </el-select>
                </div>
            </el-form-item>
            <el-form-item>
                <wcinput :option="{placeholder:'操作名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetSuperLog();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetSuperLog()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-superlog-obj">
        <el-table :data="loglist" stripe="true" empty-text="" ref="pet">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column label="操作名称" prop="name" align="center" />
            <el-table-column label="操作接口" prop="shopname" align="center">
                <template #default="scope">
                {{scope.row.controller}}_{{scope.row.action}}
                </template>
            </el-table-column>
            <el-table-column label="操作店铺" prop="shopname" align="center" />
            <el-table-column label="操作人" prop="managername" align="center" />
            <el-table-column label="操作渠道" prop="channel" align="center" />
            <el-table-column label="操作时间" prop="inputtime" align="center" />
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <wcbutton :option="{title:'查看'}" @finish="GetRequest(scope.row)" />
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetSuperLog();
                    }"
                />
            </div>
        </div>
    </div>

</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_PLAT_SETTING from '@/Interface/Platsetting/Platsetting';
export default {
    components:{},
    data() {
        return {
            param: {
                date:''+new Date().getFullYear()+'',
                time:[],
                shopid:'',
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            shoplist:[],
            changeSelectIndex:'',
            loglist:[],

            showpostdata: {
                dialog:false,
                data:'',
            },

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSuperLog();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetSuperLog();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetSuperLog();
            }else {
                this.GetSuperLog();
            }
        },


        /** 标记当前正在选择的会员 **/
        changeSelect(index) {
            this.changeSelectIndex=index;
        },

        /** 获取账号模板 **/
        GetShopLists(keyname) {
            if(!keyname || keyname=='') return false; //传入空字符串时不执行搜索
            var param={key:keyname,p:1,rollpage:1000000};
            INTERFACE_MODEL_SHOP.GET_PLATFORM_SHOP(param).then((res) => {
                 if(res.status > 0) return false;
                 var shops=res.data.list;
                 this.shoplist=shops;
            });
        },


        //获取日志信息
        GetSuperLog() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-superlog-obj");
            this.$loading.openloading(obj);
            INTERFACE_PLAT_SETTING.CHECK_SUPER_LOG(this.param).then((res) => {
                this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.loglist=res.data.list;
            });
        },


        /** 获取提交参数 **/
        GetRequest(item) {
            this.showpostdata.dialog=true;
            this.showpostdata.data={};
        },



    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-shopinfo {display:inline-flex;align-items: center;width:100%}
.TTL-pet-image {position: relative;display: inline-block;width:60px;height: 60px;}
.TTL-pet-shoptitle {width:calc(100% - 60px - 20px);margin-left:20px;text-align: left;}
.TTL-shopname {width:100%;font-size:13px;display: inline-block;}
.TTL-level {width:100%;font-size:12px;color:#666666;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:25px;
    height:25px;
    border-radius: 50%;
    background-color: #ffffff;
    background-image:url(@/assets/icon/isplatform.png);
    background-repeat: no-repeat;
    background-size: 14px;
    background-position: center;
}
.handletime {display: inline-block;width:100%;font-size:12px;}
.TTL-names {font-weight: 550;letter-spacing: 1px;}
.TTL-names i {font-style: normal;font-weight: 500;color:#999999;font-size:12px;zoom:.9;}
.TTL-shopname {color:#999999;font-size:12px;}
</style>